let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fNRu3")).then(() => parcelRequire('6YYOX'));